import React, {useCallback} from 'react';
import {twMerge} from 'tailwind-merge';

import ColorPicker from '../../../../components/ColorPicker';
import {SettingLabel} from '../components/SettingLabel';
import {SemanticLegendSettingsWithCategoricalConfig} from '../types';
import {DEFAULT_SEMANTIC_LEGEND_SETTINGS} from './SemanticLegendDefaults';

export type SemanticLegendExcludedRunColorProps = {
  excludedRunColor: string;
  updateSetting: (
    settings: Partial<SemanticLegendSettingsWithCategoricalConfig>
  ) => void;
};

export const SemanticLegendExcludedRunColor = ({
  updateSetting,
  excludedRunColor,
}: SemanticLegendExcludedRunColorProps) => {
  const updateSettingValue = useCallback(
    (newVal?: string) => {
      updateSetting({
        excludedRunColor:
          newVal || DEFAULT_SEMANTIC_LEGEND_SETTINGS.excludedRunColor,
      });
    },
    [updateSetting]
  );
  return (
    <div
      className={twMerge('flex w-full', 'items-center', 'gap-20 py-16')}
      data-test="excluded-run-color-setting">
      <SettingLabel text="Excluded runs color" className="w-full min-w-fit" />
      <ColorPicker
        activeColor={excludedRunColor}
        setColor={updateSettingValue}
        trigger="button"
      />
    </div>
  );
};
